//#region Styles
import { Container } from "./styles";
//#endregion

const ImageOption = ({
	title,
	src,
	onClick,
	selected,
	disabled,
	error = false,
}) => {
	const getClassName = () => {
		const classList = [];
		error && classList.push("error");
		selected && classList.push("selected");
		disabled && classList.push("disabled");
		return classList.join(" ");
	};
	return (
		<Container
			onClick={() => !disabled && onClick()}
			className={getClassName()}
		>
			<img
				src={src}
				alt={title}
			/>
			<span>{title}</span>
		</Container>
	);
};

export default ImageOption;
